import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { clearFormInput } from 'actions/FormActions';
import { patientViewCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
import { getPatientDetails, getPatientOrders, getRewardPoints, resetPatientLists, updateRewardPoint, getPrescriptions, updateVisitCount } from 'actions/EntityActions';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';

import PatientHeader from './components/PatientHeader';
import PatientTabMenu from './components/PatientTabMenu';
import RewardPoints from './components/RewardPoints';
import VisitPoints from './components/VisitPoints';


const pageName = "PatientView";
//View screen for displaying all the information of the patient

class PatientView extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            display: 'view',
            errors: [],
            rewardPoints: {
                activePage: 1,
                itemsPerPage: 10,
                pointAmount: 0
            },
            orders: {
                activePage: 1,
                itemsPerPage: 10
            },
            tabs: {
                value: "information"
            },
            openPointsDiag: false,
            openVisitsDiag: false,
            orderDropDownValue: 1
        };
        this.handleTabs = this.handleTabs.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.loadOrders = this.loadOrders.bind(this);
        this.loadPrescriptions = this.loadPrescriptions.bind(this);
        this.loadPoints = this.loadPoints.bind(this);
        this.changePage = this.changePage.bind(this);
        this.openPoints = this.openPoints.bind(this);
        this.closePoints = this.closePoints.bind(this);
        this.openVisits = this.openVisits.bind(this);
        this.closeVisits = this.closeVisits.bind(this);
        this.directToPatientEdit = this.directToPatientEdit.bind(this);
        this.addVisit = this.addVisit.bind(this);
        this.removeVisit = this.removeVisit.bind(this);
        this.addRewardPoints = this.addRewardPoints.bind(this);
        this.removeRewardPoints = this.removeRewardPoints.bind(this);
    }

    componentWillMount() {
        this.props.getPatientDetails({ id: this.props.params.id, branchId: this.props.branchId });
    }

    componentWillReceiveProps(newProps) {
        if (newProps.rewardSuccess !== undefined && newProps.rewardSuccess !== this.props.rewardSuccess && newProps.rewardSuccess !== null) {
            if (newProps.rewardSuccess) {
                this.setRewardSuccess();
            } else {
                this.setRewardFailed();
            }
        }
        if (newProps.visitSuccess !== undefined && newProps.visitSuccess !== this.props.visitSuccess && newProps.visitSuccess !== null) {
            if (newProps.visitSuccess) {
                this.setVisitSuccess();
            } else {
                this.setVisitFailed();
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.orderDropDownValue !== this.state.orderDropDownValue) {
            this.setState(prevState => ({ orders: { ...prevState.orders, activePage: 1 } }), () => {
                this.getOrders(this.state.orderDropDownValue);
            });
        }
    }

    componentWillUnmount() {
        this.props.resetPatientLists();
    }

    handleTabs(e, value) {
        console.log(value)
        this.setState(prevState => ({
            tabs: {
                ...prevState.tabs,
                value: value
            }
        }));
    }

    /* To Open and Hide Modal */
    openPoints() {
        this.setState({ openPointsDiag: true });
    }

    closePoints() {
        this.setState({ openPointsDiag: false });
    }

    openVisits() {
        this.setState({ openVisitsDiag: true });
    }

    closeVisits() {
        this.setState({ openVisitsDiag: false });
    }

    setRewardSuccess() {
        this.props.setRewardSnack("Reward points changed successfully.");
        this.props.resetReward();

        this.setState(prevState => {
            return {
                ...prevState,
                openPointsDiag: false
            }
        }, () => this.props.getPatientDetails(this.props.params.id));
        this.getRewardPoints();
    }

    setRewardFailed() {
        this.props.setRewardSnack("Error changing reward points.");
        this.props.resetReward();

        this.setState(prevState => {
            return {
                ...prevState,
                openPointsDiag: false
            }
        }, () => this.props.getPatientDetails(this.props.params.id));
    }

    setVisitSuccess() {
        this.props.setRewardSnack("Visit Count changed successfully.");
        this.props.resetVisit();

        this.setState(prevState => {
            return {
                ...prevState,
                openVisitsDiag: false
            }
        }, () => this.props.getPatientDetails(this.props.params.id));
    }

    setVisitFailed() {
        this.props.setRewardSnack("Error changing visit count.");
        this.props.resetVisit();

        this.setState(prevState => {
            return {
                ...prevState,
                openVisitsDiag: false
            }
        }, () => this.props.getPatientDetails(this.props.params.id));
    }

    /* Direct to the Patient Edit Page */
    directToPatientEdit() {
        this.props.navigate(`/member/edit/${this.props.params.id}`);
    }


    /* Validate the reward point when clicking the save button */
    validateRewardPoints() {

        const patient = this.props.patientDetail;
        let rewardPoints;
        if (this.props.rewardPointAction === 'Remove') {
            rewardPoints = this.props.rewardPointAmount;
        } else {
            rewardPoints = this.props.rewardPointAmount;
        }

        let model = {
            PatientId: patient.id,
            BranchId: patient.branchId,
            Comments: this.props.commentRewardPoint || "",
            Points: rewardPoints
        };

        this.props.setRewardPoints(model, pageName);
        this.resetRewardForm();
    }

    addRewardPoints() {
        const patient = this.props.patientDetail;

        const model = {
            patientId: patient.id,
            branchId: this.props.branchId,
            comments: this.props.rewardComment,
            points: this.props.rewardAmount
        }

        this.props.updateRewardPoint(model, pageName);
        this.resetRewardForm();
    }

    removeRewardPoints() {
        const patient = this.props.patientDetail;

        //if there is an issue with this.props.rewardAmount or patient.rewardPoints in the front end, deducting more then a patient has will be caught in the back end as well
        if (this.props.rewardAmount && patient.rewardPoints && patient.rewardPoints < this.props.rewardAmount) {
            this.props.setRewardSnack("Cannot deduct more points then current balance");
            return;
        }

        const model = {
            patientId: patient.id,
            branchId: this.props.branchId,
            comments: this.props.rewardComment,
            points: this.props.rewardAmount,
            remove: true
        }

        this.props.updateRewardPoint(model, pageName);
        this.resetRewardForm();
    }


    addVisit() {
        const patient = this.props.patientDetail;

        const model = {
            patientId: patient.id,
            visits: this.props.visitAmount
        }
        this.props.updateVisitCount(model);
        this.resetVisitForm();
    }

    removeVisit() {
        const patient = this.props.patientDetail;

        const model = {
            patientId: patient.id,
            visits: this.props.visitAmount,
            remove: true
        }

        this.props.updateVisitCount(model);
        this.resetVisitForm();
    }

    /**
     * @Param page Number - Page to be active
     * @Param compName String - Name of the component to change page
     */
    changePage(page, compName) {
        if (compName === 'points') {
            this.setState(prevState => {
                return {
                    ...prevState,
                    rewardPoints: {
                        ...prevState.rewardPoints,
                        activePage: page
                    }
                };
            }, () => this.getRewardPoints());
        }

        if (compName === 'orders') {
            this.setState(prevState => {
                return {
                    ...prevState,
                    orders: {
                        ...prevState.orders,
                        activePage: page
                    }
                };
            }, () => this.getOrders());
        }

        if (compName === 'prescriptions') {
            this.setState(prevState => {
                return {
                    ...prevState,
                    prescriptions: {
                        ...prevState.prescriptions,
                        activePage: page
                    }
                };
            }, () => this.getPrescriptions());
        }

    }

    // Get reward points
    getRewardPoints() {
        let model = {
            patientId: this.props.patientDetail.id,
            activePage: this.state.rewardPoints.activePage,
            itemsPerPage: this.state.rewardPoints.itemsPerPage
        };
        this.props.getRewardPoints(model);
    }

    resetRewardForm() {
        this.props.clearFormInput('Comment');
        this.props.clearFormInput('Amount');
    }

    resetVisitForm() {
        this.props.clearFormInput('VisitAmount');
    }

    // Load Reward Point
    loadRewardPoints() {
        if (this.props) {
            return (this.props.rewardPointList || []).map(r => {
                return {
                    Date: r.date,
                    Point: r.point,
                    Comment: r.comment
                };
            });
        }
        return [];
    }

    loadOrders() {
        this.getOrders();
    }

    loadPoints() {
        if (!Object.prototype.hasOwnProperty.call(this.props.rewardPoint, 'list')) {
            this.getRewardPoints();
        }
    }

    loadPrescriptions() {
        this.getPrescriptions();
    }

    getOrderModel(option) {
        const baseModel = {
            branchId: 0,
            orderNumber: null,
            orderDate: null,
            patientFirstName: "",
            employeeFirstName: "",
            status: 'None',
            total: null,
            orderBy: "DESC",
            sortBy: "Id",
            innerClass: "",
            employeeId: null,
            patientId: this.props.patientDetail.id,
            page: this.state.orders.activePage,
            itemsPerPage: this.state.orders.itemsPerPage
        };

        const options = {
            1: baseModel,
            2: { ...baseModel, IsOnline: true },
            3: { ...baseModel, IsOnline: false }
        };

        return options[option];
    }

    getOrders(option = 1) {
        const model = this.getOrderModel(option);
        this.props.getPatientOrders(model);
    }

    getPrescriptions() {
        this.props.getPrescriptions(this.props.patientDetail.id);
    }

    handleChange(event) {
        this.setState({ orderDropDownValue: event.target.value });
    }

    render() {
        const hideBCRewards = this.props.store && this.props.store.provinceState && (this.props.store.provinceState.toLowerCase() == "bc" || this.props.store.provinceState.toLowerCase() == "british columbia") && !this.props.isMedical;
        const patient = this.props.patientDetail;
        const orders = {
            orders: this.props.patientOrders,
            pagination: {
                ...this.state.orders
            }
        };
        let totalMemberSavings = 0;

        this.props.patientOrders.list ? this.props.patientOrders.list.map(item => totalMemberSavings += item.memberSavingTotal) : 0

        const points = {
            points: this.props.rewardPoint,
            pagination: {
                ...this.state.rewardPoints
            }
        };

        const patientHeader = {
            patientPhoto: patient.photo,
            fullName: patient.fullName,
            patientID: patient.id,
            gender: patient.gender,
            age: patient.age,
            totalPoints: patient.rewardPoints,
            visitCount: patient.visitCount,
            totalSpent: patient.totalSpent,
            lastOrder: patient.lastOrder || "No Orders",
            ordersTotal: patient.ordersTotal,
            store: this.props.store,
            eliteMemberStartDate: patient.eliteMemberStartDate,
            eliteMemberEndDate: patient.eliteMemberEndDate,
            canModifyEliteMember: this.props.canModifyEliteMember
        }
        return (
            <Grid headerContent={patientViewCrumb}>
                {/* Header - Breadcrumb */}
                <div className="position-relative bg-light-opacity" id="patient-view-container">
                    <CardSimple>
                        <PatientHeader {...patientHeader}
                            openPoints={this.openPoints}
                            openVisits={this.openVisits}
                            showPoints={this.props.springBigEnabled}
                            totalMemberSavings={totalMemberSavings}
                            tabValue={this.state.tabs.value}
                            hideBCRewards={hideBCRewards}
                            accessRole={this.props.canViewMemberTotalSpent}
                            directToPatientEdit={this.directToPatientEdit} />
                        {/* Tab Menu */}
                        <PatientTabMenu
                            patientInfo={patient}
                            orders={orders}
                            points={points}
                            prescriptions={this.props.prescriptions}
                            loadOrder={this.loadOrders}
                            loadPoints={this.loadPoints}
                            loadPrescriptions={this.loadPrescriptions}
                            changePage={this.changePage}
                            handleTabs={this.handleTabs}
                            tabValue={this.state.tabs.value}
                            store={this.props.store}
                            hidepoints={this.props.springBigEnabled}
                            handleChange={this.handleChange}
                            orderDropDownValue={this.state.orderDropDownValue}
                            isVape={this.props.isVape}
                            hideBCRewards={hideBCRewards}
                        />
                    </CardSimple>
                    <RewardPoints
                        openDiag={this.state.openPointsDiag}
                        closePoints={this.closePoints}
                        addRewardPoints={this.addRewardPoints}
                        removeRewardPoints={this.removeRewardPoints}
                    />
                    <VisitPoints
                        openDiag={this.state.openVisitsDiag}
                        closeVisits={this.closeVisits}
                        addVisits={this.addVisit}
                        removeVisits={this.removeVisit}
                    />
                </div>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        patientDetail: state.entity.patientDetail,
        patientOrders: state.entity.patientOrders,
        prescriptions: state.entity.prescriptions,
        inputRewardPoint: state.form.PointHistoryRewardPoint,
        rewardPointAmount: parseInt(state.form.PatientViewPointAmount),
        commentRewardPoint: state.form.PatientViewPointComment,
        rewardPointAction: state.form.patientRewardOption,
        rewardPoint: state.entity.patientRewardPoints,
        branchId: state.common.branchId,
        rewardAmount: state.form.Amount,
        rewardComment: state.form.Comment,
        visitAmount: state.form.VisitAmount,
        rewardSuccess: state.entity.setReward,
        visitSuccess: state.entity.setVisit,
        springBigEnabled: state.common.applicationSettings.springbigApiKey || state.common.applicationSettings.alpineIQApiKey,
        store: state.common.store,
        isVape: state.common.applicationSettings.isVape,
        isMedical: state.common.applicationSettings.isMedical,
        canViewMemberTotalSpent: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanViewMemberTotalSpent")),
        canModifyEliteMember: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanEditEliteMembership"))
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPatientDetails: (model) => dispatch(getPatientDetails(model)),
        updateRewardPoint: (model, compName) => dispatch(updateRewardPoint(model, compName)),
        updateVisitCount: (model) => dispatch(updateVisitCount(model)),
        getRewardPoints: (model) => dispatch(getRewardPoints(model)),
        getPatientOrders: (model) => dispatch(getPatientOrders(model)),
        getPrescriptions: (patientId) => dispatch(getPrescriptions(patientId)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        resetPatientLists: () => dispatch(resetPatientLists()),
        setRewardSnack: (message) => dispatch({ type: types.SNACKBAR_SHOW_MESSAGE, message: message }),
        resetReward: () => dispatch({ type: types.SET_PATIENT_REWARD_RESET }),
        resetVisit: () => dispatch({ type: types.SET_PATIENT_VISIT_RESET })
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(PatientView));
